module.exports = __webpack_public_path__ + "static/media/404-500-bg-3.72560c43.jpg";